import { getAllResources } from "../services/api";

var LANG = 'pt';
var RESOURCES: { [x: string]: { [x: string]: string; }; } | null = null;
export const getResource = (field: string) => {
    let label = "";
    let language = getLanguage() ?? LANG;
  
    //getApiResources();
    try {
        if(RESOURCES !== null){
            label = RESOURCES[field][language];
        }
    } catch (error) {
        label = `${field}_NOT_FOUND`;
    }
    return label;
}
export const getLanguage = () =>{
    if(sessionStorage.getItem("LANGUAGE") !== null){
        return sessionStorage.getItem("LANGUAGE")?.toString();       
    }
    return null;
}
export const setLanguage = (lang : string) => {
    LANG = lang;
    sessionStorage.setItem("LANGUAGE", lang);
    //window.location.reload();
}
export const getApiResources = () =>{
 console.log(RESOURCES);
    if(RESOURCES == null){
        getAllResources().then((res: any) => {
            RESOURCES = res.data;
        });
    }
}
